import { AudioPlaybackProvider } from "@/context/audio-playback-context";
import { ErrorBoundary } from "@/components/common/error-boundary";
import { LearnLanguageProvider } from "@/context/learn-language-context";
import { PocketProvider } from "@/context/pocketbase-context";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { VoiceInputProvider } from "@/context/voice-input-context";
import { routers } from "@/routes";

function App() {
  return (
    <ErrorBoundary>
      <PocketProvider>
        <LearnLanguageProvider>
          <AudioPlaybackProvider>
            <VoiceInputProvider>
              <RouterProvider router={routers} />
              <Toaster richColors position="bottom-right" />
            </VoiceInputProvider>
          </AudioPlaybackProvider>
        </LearnLanguageProvider>
      </PocketProvider>
    </ErrorBoundary>
  );
}

export default App;
